import Vue from "vue";

const getDefaultState = () => {
  return {
    space: {},
    sidebarElements: [],
    properties: [],
  };
};

const state = Vue.observable(getDefaultState());

const methods = {
  RESET_STATE() {
    Object.assign(state, getDefaultState());
  },

  setSpace(space) {
    state.space = space;
  },
};

const SpaceStore = {
  state,
  methods,
};
export default SpaceStore;
